import axios from "../../services/axios.config";

const endpoints = {
  projectInnerCard: `api/projects/inner_card/`,
  addProjectSkill: `api/projects/skills/add/`,
  removeProjectSkill: `api/projects/skills/remove/`,
  addProjectRole: `api/projects/roles/add/`,
  removeProjectRole: `api/projects/roles/remove/`,
  addProjectPlatform: `api/projects/platforms/add/`,
  removeProjectPlatform: `api/projects/platforms/remove/`,
  addProjectUser: `api/projects/users/add/`,
  removeProjectUser: `api/projects/users/remove/`,
  addProjectImage: `api/projects/images/add/`,
  removeProjectImage: `api/projects/images/remove/`,
  addProjectClient: `api/projects/clients/add/`,
  updateProjectClient: `api/projects/clients/update/`,
  addProjectDescription: `api/projects/translations/add/`,
  updateProjectDescription: `api/projects/translations/update/`,
  updateProjectBudget: `api/projects/update_budget/`,
  updateProjectUrl: `api/projects/update_url/`,
  uploadImages: `api/projects/images/upload/`,
  fetchSkills: `api/skill/skill_list/`,
  fetchRoles: `api/role/job_role_list/`,
  fetchUsers: `api/users/team-members/list/`,
  fetchClient: `api/clients/client_list/`,
  fetchLanguages: `api/language/`,
  fetchPlatforms: `api/platforms/`,
};

const state = {
  innerCard: {},
  projectPlatforms: [],
  projectSkills: [],
  projectRoles: [],
  projectUsers: [],
  projectImages: [],
  projectTranslations: [],
  projectClient: [],
  platforms: [],
  skills: [],
  users: [],
  roles: [],
  languages: [],
  clients: [],
};

const getters = {
  getInnerCardDetail: (state) => state.innerCard,
  getProjectPlatforms: (state) => state.projectPlatforms,
  getProjectUsers: (state) => state.projectUsers,
  getProjectSkills: (state) => state.projectSkills,
  getProjectRoles: (state) => state.projectRoles,
  getProjectTranslations: (state) => state.projectTranslations,
  getProjectImages: (state) => state.projectImages,
  getProjectClient: (state) => state.projectClient,
  getSkillList: (state) => state.skills,
  getRoleList: (state) => state.roles,
  getLanguageList: (state) => state.languages,
  getPlatformList: (state) => state.platforms,
  getClientList: (state) => state.clients,
  getUserList: (state) => state.users,
};

const actions = {
  async FetchInnerCard({commit}, id) {
    try {
      const response = await axios.get(
        endpoints.projectInnerCard + `?project_id=${id}`
      );
      // noinspection ES6MissingAwait - these are awaited in Promise.all
      const requests = [
        axios.get(endpoints.fetchClient),
        axios.get(endpoints.fetchUsers),
        axios.get(endpoints.fetchSkills),
        axios.get(endpoints.fetchRoles),
        axios.get(endpoints.fetchLanguages),
        axios.get(endpoints.fetchPlatforms),
      ];
      const results = await Promise.all(requests);

      const finalData = await Promise.all(
        results.map((result) => {
          return result.data;
        })
      );

      commit("SET_INNER_CARD", response.data.result);
      commit("SET_CLIENT_LIST", finalData[0]);
      commit("SET_USER_LIST", finalData[1]);
      commit("SET_SKILL_LIST", finalData[2]);
      commit("SET_JOB_ROLE_LIST", finalData[3]);
      commit("SET_LANGUAGE_LIST", finalData[4]);
      commit("SET_PLATFORM_LIST", finalData[5]);
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async UploadProjectImage({commit}, value) {
    try {
      const response = await axios.post(endpoints.uploadImages, value);
      if (response.data.status === 200) return response.data.result.image_ids;
      commit();
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },
  async CreateProjectImage({commit}, value) {
    try {
      const response = await axios.post(endpoints.addProjectImage, value);
      if (
        response.data.status === 200 &&
        response.data.result !== "No change"
      ) {
        commit("SET_ADD_PROJECT_IMAGE", response.data.result);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },
  async DeleteProjectImage({commit}, value) {
    try {
      const response = await axios.post(endpoints.removeProjectImage, value);
      if (response.data.status === 200) {
        commit("SET_DELETE_PROJECT_IMAGE", response.data.result.id);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },
  async CreateProjectPlatform({commit}, value) {
    try {
      const response = await axios.post(endpoints.addProjectPlatform, value);
      if (
        response.data.result !== "No change" &&
        response.data.status === 200
      ) {
        commit("SET_ADD_PROJECT_PLATFORM", response.data.result);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },
  async DeleteProjectPlatform({commit}, value) {
    try {
      const response = await axios.post(endpoints.removeProjectPlatform, value);
      if (response.data.status === 200) {
        commit("SET_DELETE_PROJECT_PLATFORM", response.data.result.id);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async CreateProjectSkill({commit}, value) {
    try {
      const response = await axios.post(endpoints.addProjectSkill, value);
      if (
        response.data.result !== "No change" &&
        response.data.status === 200
      ) {
        commit("SET_ADD_PROJECT_SKILL", response.data.result);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async DeleteProjectSkill({commit}, value) {
    try {
      const response = await axios.post(endpoints.removeProjectSkill, value);
      commit("SET_DELETE_PROJECT_SKILL", response.data.result.id);
      if (response.data.status === 200) {
        commit("SET_DELETE_PROJECT_SKILL", response.data.result.id);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async CreateProjectRole({commit}, value) {
    try {
      const response = await axios.post(endpoints.addProjectRole, value);
      if (
        response.data.result !== "No change" &&
        response.data.status === 200
      ) {
        commit("SET_ADD_PROJECT_ROLE", response.data.result);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async DeleteProjectRole({commit}, value) {
    try {
      const response = await axios.post(endpoints.removeProjectRole, value);
      if (response.data.status === 200) {
        commit("SET_DELETE_PROJECT_ROLE", response.data.result.id);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async CreateProjectUser({commit}, value) {
    try {
      const response = await axios.post(endpoints.addProjectUser, value);
      if (
        response.data.result !== "No change" &&
        response.data.status === 200
      ) {
        commit("SET_ADD_PROJECT_USER", response.data.result);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async DeleteProjectUser({commit}, value) {
    try {
      const response = await axios.post(endpoints.removeProjectUser, value);
      if (response.data.status === 200) {
        commit("SET_DELETE_PROJECT_USER", response.data.result.id);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async CreateProjectClient({commit}, value) {
    try {
      const response = await axios.post(endpoints.addProjectClient, value);
      if (response.data.status === 200) {
        commit("SET_ADD_PROJECT_CLIENT", response.data.result);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async UpdateProjectClient({commit}, value) {
    try {
      const response = await axios.post(endpoints.updateProjectClient, value);
      if (response.data.status === 200) {
        commit("SET_UPDATE_PROJECT_CLIENT", response.data.result);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async CreateProjectTranslation({commit}, value) {
    try {
      const response = await axios.post(endpoints.addProjectDescription, value);
      if (response.data.status === 200) {
        commit("SET_ADD_PROJECT_DETAIL_DESCRIPTION", response.data.result);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async UpdateProjectDetailDescription({commit}, value) {
    try {
      const response = await axios.post(
        endpoints.updateProjectDescription,
        value
      );
      if (response.data.status === 200) {
        commit("SET_UPDATE_PROJECT_DETAIL_DESCRIPTION", value);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },

  async UpdateProjectBudget({commit}, value) {
    try {
      const response = await axios.post(endpoints.updateProjectBudget, value);
      if (response.data.status === 200) {
        commit("SET_UPDATE_PROJECT_BUDGET", value);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },
  async UpdateProjectUrl({commit}, value) {
    try {
      const response = await axios.post(endpoints.updateProjectUrl, value);
      if (response.data.status === 200) {
        commit("SET_UPDATE_PROJECT_URL", value);
      }
    } catch (err) {
      console.log("Error", JSON.stringify(err));
    }
  },
};

const mutations = {
  SET_UPDATE_PROJECT_BUDGET: (state, value) => {
    if (state.innerCard.project_id === Number(value.id)) {
      state.innerCard.project_budget = value.project_budget;
    }
  },

  SET_UPDATE_PROJECT_URL: (state, value) => {
    if (state.innerCard.project_id === Number(value.id)) {
      state.innerCard.project_website = value.project_catch_copy;
    }
  },

  SET_INNER_CARD: (state, value) => {
    state.innerCard = value;
    state.projectTranslations = value.descriptions;
    state.projectPlatforms = value.platforms;
    state.projectSkills = value.skills;
    state.projectRoles = value.roles;
    state.projectUsers = value.members;
    state.projectImages = value.images;
    state.projectClient = value.client;
  },

  SET_CLIENT_LIST: (state, value) => {
    state.clients = value;
  },
  SET_PLATFORM_LIST: (state, value) => {
    state.platforms = value;
  },

  SET_LANGUAGE_LIST: (state, value) => {
    state.languages = value;
  },

  SET_SKILL_LIST: (state, value) => {
    state.skills = value;
  },

  SET_JOB_ROLE_LIST: (state, value) => {
    state.roles = value;
  },

  SET_USER_LIST: (state, value) => {
    state.users = value;
  },

  SET_ADD_PROJECT_PLATFORM: (state, value) => {
    value.forEach((element) => {
      state.projectPlatforms.push(element);
    });
  },

  SET_ADD_PROJECT_SKILL: (state, value) => {
    value.forEach((element) => {
      state.projectSkills.push(element);
    });
  },

  SET_ADD_PROJECT_ROLE: (state, value) => {
    value.forEach((element) => {
      state.projectRoles.push(element);
    });
  },

  SET_ADD_PROJECT_CLIENT: (state, value) => {
    state.projectClient = value;
  },

  SET_UPDATE_PROJECT_CLIENT: (state, value) => {
    state.projectClient = value;
  },

  SET_ADD_PROJECT_USER: (state, value) => {
    value.forEach((element) => {
      state.projectUsers.push(element);
    });
  },

  SET_ADD_PROJECT_IMAGE: (state, value) => {
    value.forEach((element) => {
      state.projectImages.push(element);
    });
  },

  SET_ADD_PROJECT_DETAIL_DESCRIPTION: (state, value) => {
    state.projectTranslations.push(value);
  },

  SET_UPDATE_PROJECT_DETAIL_DESCRIPTION: (state, value) => {
    state.projectTranslations = state.projectTranslations.map((element) => {
      if (element.id === value.id) {
        element.project_detail_description = value.project_detail_description;
      }
      return element;
    });
  },

  SET_DELETE_PROJECT_PLATFORM: (state, id) => {
    const index = state.projectPlatforms.findIndex((item) => item.id === id);
    if (index !== -1) state.projectPlatforms.splice(index, 1);
  },

  SET_DELETE_PROJECT_SKILL: (state, id) => {
    const index = state.projectSkills.findIndex((item) => item.id === id);
    if (index !== -1) state.projectSkills.splice(index, 1);
  },

  SET_DELETE_PROJECT_ROLE: (state, id) => {
    const index = state.projectRoles.findIndex((item) => item.id === id);
    if (index !== -1) state.projectRoles.splice(index, 1);
  },

  SET_DELETE_PROJECT_USER: (state, id) => {
    const index = state.projectUsers.findIndex((item) => item.id === id);
    if (index !== -1) state.projectUsers.splice(index, 1);
  },

  SET_DELETE_PROJECT_IMAGE: (state, id) => {
    const index = state.projectImages.findIndex((item) => item.id === id);
    if (index !== -1) state.projectImages.splice(index, 1);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
